import React from 'react';

import { Button, Icon } from '../../../components/common';
import { TextSelect } from '../../../components/products/ProductModal';
import {
  BoxReplicate,
  FlexCol,
  FlexRow,
  Footer,
  H2,
  Label,
  ReplicateSubtitle,
  ReplicateTitle
} from '../style';
import styled from 'styled-components';
import { useStore } from '../../../providers/store.provider';

const NoBaseMessage = styled.div`
  font-size: 14px;
  color: ${(props) => props.theme.colors.error};
`;

const StepOrigin = ({
  valueReplicate,
  handleChangeReplicate,
  categories,
  selectedCategorie,
  handleSelectCategorie,
  products,
  selectedProduct,
  handleSelectProduct,
  handleChange
}) => {
  const validateIsDisabled = () => {
    if (!valueReplicate) return true;
    else if (valueReplicate === 'product' && selectedCategorie === null) return true;
    else if (valueReplicate === 'product' && selectedProduct === null) return true;
    else return false;
  };

  const storeProvider = useStore();
  const selectedStore = storeProvider.selectedMultistore;

  return (
    <>
      <H2>O que deseja replicar?</H2>
      <FlexRow>
        <BoxReplicate
          className={valueReplicate === 'replicate' ? 'selected' : ''}
          onClick={() => handleChangeReplicate('replicate')}
        >
          <Icon
            width={'56px'}
            height={'56px'}
            name={'replicateMenu'}
            stroke={'primary'}
          />
          <ReplicateTitle>Cardápio Completo</ReplicateTitle>
          <ReplicateSubtitle>Replicar todas as categorias e produtos.</ReplicateSubtitle>
        </BoxReplicate>
        <BoxReplicate
          className={valueReplicate === 'product' ? 'selected' : ''}
          onClick={() => handleChangeReplicate('product')}
        >
          <Icon
            width={'56px'}
            height={'56px'}
            name={'replicatePodruct'}
            stroke={'primary'}
          />
          <ReplicateTitle>Produto</ReplicateTitle>
          <ReplicateSubtitle>Replicar apenas um produto específico.</ReplicateSubtitle>
        </BoxReplicate>
      </FlexRow>
      <FlexCol>
        {categories && categories.length > 0 && valueReplicate === 'product' && (
          <>
            <Label>Categoria</Label>
            <TextSelect
              minWidth={'150px'}
              selected={selectedCategorie}
              onChange={handleSelectCategorie}
              options={categories.map((cat, i) => {
                return {
                  name: cat.name,
                  value: cat.id
                };
              })}
            />
            <Label>Produto</Label>
            <TextSelect
              minWidth={'150px'}
              selected={selectedProduct}
              onChange={handleSelectProduct}
              options={
                (products &&
                  products.length > 0 &&
                  products.map((product) => {
                    return {
                      name: product.name,
                      value: product.id
                    };
                  })) || []
              }
            />
          </>
        )}
      </FlexCol>
      {
        (!selectedStore || !selectedStore?.baseToReplicateItems) && (
          <NoBaseMessage>
            Atenção! Você está prestes a replicar um item de uma loja que não é a loja base.*
            <br />
            *nas lojas base os produtos criados são configurados automaticamente para a funcionalidade de réplica, não sendo necessária configurações adicionais.
          </NoBaseMessage>
        )
      }
      <Footer>
        <Button
          className="default-error"
          width={'80px'}
        >
          Cancelar
        </Button>
        <Button
          disabled={validateIsDisabled()}
          className="success"
          width={'80px'}
          onClick={() => handleChange('destiny')}
        >
          Continuar
        </Button>
      </Footer>
    </>
  );
};

export default StepOrigin;
